import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const FaqSection = ({ faqs }) => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFaq = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    if (!faqs || faqs.length === 0) return null;

    return (
        <div className="mt-12 border-t border-gray-200 pt-8">
            <h2 className="mb-8 text-2xl md:text-3xl font-bold text-gray-900 text-center">
                الأسئلة الشائعة
            </h2>
            <div className="space-y-4 max-w-3xl mx-auto">
                {faqs.map((faq, index) => (
                    <div
                        key={index}
                        className={`border border-gray-200 rounded-xl overflow-hidden transition-all duration-300 ${
                            openIndex === index
                                ? "bg-blue-50/50 border-blue-100 shadow-sm"
                                : "bg-white hover:border-blue-200 hover:bg-gray-50/50"
                        }`}
                    >
                        <button
                            onClick={() => toggleFaq(index)}
                            className="w-full flex items-center justify-between p-5 text-right focus:outline-none gap-4"
                            aria-expanded={openIndex === index}
                        >
                            <span
                                className={`font-semibold text-lg leading-relaxed ${
                                    openIndex === index
                                        ? "text-blue-700"
                                        : "text-gray-800"
                                }`}
                            >
                                {faq.question}
                            </span>
                            <div
                                className={`p-1 rounded-full flex-shrink-0 ${
                                    openIndex === index
                                        ? "bg-blue-100"
                                        : "bg-gray-100"
                                }`}
                            >
                                {openIndex === index ? (
                                    <ChevronUp className="w-5 h-5 text-blue-600" />
                                ) : (
                                    <ChevronDown className="w-5 h-5 text-gray-500" />
                                )}
                            </div>
                        </button>

                        <div
                            className={`transition-all duration-300 ease-in-out overflow-hidden ${
                                openIndex === index
                                    ? "max-h-[500px] opacity-100"
                                    : "max-h-0 opacity-0"
                            }`}
                        >
                            <div className="p-5 pt-0 text-gray-600 leading-relaxed border-t border-blue-100/50">
                                {faq.answer}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* FAQPage JSON-LD is rendered centrally by SeoHead.jsx (see
                App\Support\BlogSeoSchema) from the same faqs data — kept out
                of this component so it isn't emitted twice on the page. */}
        </div>
    );
};

export default FaqSection;
